import { HeadingBulletList } from '@/pages/pii-training/HeadingBulletList';
import type { ContentStepProps } from '@/pages/pii-training/piiTraining.types';
import { Stack, Text } from '@careflux/primitives';

export const WhatIsPiiStep = ({ copy }: ContentStepProps) => {
  const step = copy.whatIsPii;

  return (
    <Stack as="section" gap="md">
      {step.paragraphs.map((paragraph) => (
        <Text asChild key={paragraph}>
          <p>{paragraph}</p>
        </Text>
      ))}
      <HeadingBulletList heading={step.obviousHeading} items={step.obviousExamples} />
    </Stack>
  );
};
